import { defineVuesticConfig } from 'vuestic-ui'
import colors from './colors'
import icons from './icons'
import breakpoint from './breakpoint'

export default defineVuesticConfig({
  colors,
  icons,
  breakpoint,
  components: {
    VaButton: {
      preset: 'default',
    },
    VaButtonDropdown: {
      preset: 'default',
    },
    VaIcon: {
      sizesConfig: {
        defaultSize: 19,
        sizes: {
          small: 14,
          medium: 19,
          large: 26,
        },
      },
    },
    VaModal: {
      mobileFullscreen: false,
      maxHeight: 'calc(100% - 2rem)',
      closeButton: true,
    },
    VaPagination: {
      activeButtonProps: {
        preset: 'primary',
      },
    },
    VaDataTable: {
      disableClientSideSorting: true,
    },
    presets: {
      VaButton: {
        default: {
          textColor: 'textInverted',
        },
      },
      VaButtonDropdown: {
        default: {
          textColor: 'textInverted',
        },
      },
      VaSelect: {
        small: {
          class: 'va-select--small',
          keepAnchorWidth: false,
          placement: 'bottom-end',
          width: 'min(100%, 150px)',
          style:
            '--va-input-wrapper-min-height: 24px; --va-input-wrapper-border-radius: 2px; --va-input-wrapper-width: 100px;',
        },
      },
    },
  },
})
